// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Article_wrapper__cMM5t","article-body":"Article_article-body__3XdFj"};